import axios from "axios";

const baseURL = {
  local: 'http://localhost:3000/dev',
  development: 'https://rancherapi-dev.boomitra.com',
  production: 'https://rancherapi.boomitra.com',
  prodTest: 'https://cg7iceiqt7.execute-api.us-east-2.amazonaws.com/prod-test/'
};

export default axios.create({ baseURL: baseURL[process.env.REACT_APP_ENV || 'production'],  headers: {
    'app': 'ADMIN' // or put the actual admin token/value you want
  } });
